import { acceptHMRUpdate, defineStore } from 'pinia'

export const whitelabelsStore = defineStore('whitelabels', {
	namespaced: true,
	state: () => ({
		auroraEnergy: {
			heroImage: 'img/partners/auroraenergy/img-hero-auroraenergy.webp',
			heroImageMobile:
				'img/partners/auroraenergy/img-hero-auroraenergy-mobile.webp',
			partnerLogo: 'img/partners/auroraenergy/logo-auroraenergy.webp',
			partnerLogoAltText: 'Aurora Energy',
			partnerName: 'Aurora Energy',
			partnerLogoImageClass: 'h-8 w-auto md:h-10',
			menuItemsColor: 'text-gray-700 hover:text-auroraenergy-primarydark',
			menuItemFontWeight: 'font-semibold',
			iconColorHover: 'group-hover:fill-auroraenergy-primarydark',

			styles: {
				bg: {
					borderRadius: 'rounded-lg',
					color: 'bg-auroraenergy-primary',
				},
				button: {
					bg: 'bg-auroraenergy-primary hover:bg-auroraenergy-primarydark',
					outline:
						'hover:border-auroraenergy-primarydark group border duration-300 ease-out',
					outlineText:
						'hover:text-auroraenergy-primarydark group duration-300 ease-out',
					font: 'font-campton font-semibold',
					text: 'text-auroraenergy-primary hover:text-auroraenergy-primarydark',
					hover: 'hover:text-auroraenergy-primarydark',
					underline: 'hover:decoration-auroraenergy-primarydark',
					borderRadius: 'rounded-full',
				},
				tickIcon: {
					color: 'text-auroraenergy-primary',
				},
			},
			links: {
				partnerUrl: '/partners/auroraenergy',
				loginUrl: '/partners/auroraenergy/sign-in',
				signUpUrl: '/partners/auroraenergy/sign-up',
				forgetPasswordUrl: '/partners/auroraenergy/forgot-password',
				resetPasswordUrl: '/partners/auroraenergy/reset-password',
			},
		},

		sonnenDrive: {
			heroImage: 'img/partners/sonnendrive/img-hero-sonnendrive.webp',
			heroImageMobile:
				'img/partners/sonnendrive/img-hero-sonnendrive-mobile.webp',
			partnerLogo: 'img/partners/sonnendrive/logo-sonnendrive.webp',
			partnerLogoAltText: 'sonnenDrive',
			partnerName: 'sonnenDrive',
			partnerLogoImageClass: 'h-6 2xs:h-7 w-auto',
			menuItemsColor: 'text-gray-700 hover:text-sonnendrive-primarydark',
			menuItemFontWeight: 'font-semibold',
			iconColorHover: 'group-hover:fill-sonnendrive-primarydark',

			styles: {
				bg: {
					borderRadius: 'rounded-lg',
					color: 'bg-sonnendrive-primary',
				},
				button: {
					bg: 'bg-sonnendrive-primary hover:bg-sonnendrive-primarydark',
					bgInvert: 'bg-white hover:bg-gray-100',
					outline:
						'border-gray-600 hover:border-sonnendrive-primarydark group border duration-300 ease-out',
					outlineText:
						'hover:text-sonnendrive-primarydark group duration-300 ease-out',
					font: 'font-campton font-semibold',
					text: 'text-sonnendrive-primary hover:text-sonnendrive-primarydark',
					hover: 'hover:text-sonnendrive-primarydark',
					underline: 'hover:decoration-sonnendrive-primarydark',
					borderRadius: 'rounded',
					shadow: '',
				},
				tickIcon: {
					color: 'text-sonnendrive-primary',
				},
			},
			links: {
				partnerUrl: '/partners/sonnendrive',
				loginUrl: '/partners/sonnendrive/sign-in',
				signUpUrl: '/partners/sonnendrive/sign-up',
				forgetPasswordUrl: '/partners/sonnendrive/forgot-password',
				resetPasswordUrl: '/partners/sonnendrive/reset-password',
			},
		},
	}),

	getters: {
		getAuroraEnergyStyles(state) {
			return state.auroraEnergy
		},
		getSonnenDriveStyles(state) {
			return state.sonnenDrive
		},
	},
})

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(whitelabelsStore, import.meta.hot))
}
